import { Formik } from "formik";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { hasAuthority, KEY_AUTHORITIES } from "src/app/modules/utils/Permission";
import * as Yup from "yup";
import { AppContext } from "../../../appContext/AppContext";
import TabMenu from "../../../component/TabMenu";
import { CODE } from "../../../utils/Constant";
import { IBenhNhanV3ChuyenKhoa } from "../../models/PhanHeChuyenKhoaModel";
import {
  getObsValue, inGiayChungNhan, inPhieuPhauThuat,
} from "../../services/PhanHeChuyenKhoaService";
import FormPTTT from "./forms/FormPTTT";
import FormThongTinChiDinh from "./forms/FormThongTinChiDinh";
import ButtonInPhieu from '../../../component/button-in-phieu';
import { IInPhieuParams } from '../../../models/params';

type Props = {
  handleClose: () => void;
  handleTraKetQua: () => void;
  infoBenhNhan?: IBenhNhanV3ChuyenKhoa;
  isViewModal?: boolean;
  workFlowStatus?: any;
  handleSubmitForm: (values: any, currentId?: any, currentTab?: any) => void;
  listICD10: any;
  selectedRow: any;
  isHasData?: boolean;
  setIsHasData?: (value: boolean) => void;
};

const initialValues: any = {
  surgeryInformationEntryDate: "",
  surgeryStartTime: "",
  surgeryEndTime: "",
  surgerySurgicalDescription: "",
};

export default function ModalThucHien({
  handleClose,
  handleTraKetQua,
  infoBenhNhan,
  isViewModal,
  handleSubmitForm,
  selectedRow,
  isHasData,
  setIsHasData = () => {}
}: Props) {
  const { setIsLoading } = useContext(AppContext);
  const [inforResult, setInforResult] = useState<any>({});
  const refForm = useRef<any>();
  const [currentTab, setCurrentTab] = useState(0);
  const [validationSchema, setValidationSchema] = useState<any>(Yup.object({}));
  const [listTabChecked, setListTabChecked] = useState<any>([]);
  const editable = hasAuthority(KEY_AUTHORITIES.CHUYEN_KHOA.FORM_THUC_HIEN.EDIT) || hasAuthority(KEY_AUTHORITIES.CHUYEN_KHOA.FORM_CHI_DINH.EDIT);

  useEffect(() => {
    setValidationSchema(
      !currentTab
        ? Yup.object({
          formData: Yup.object({
            surgerySurgicalDescription: Yup.string().nullable().required("Bắt buộc nhập"),
          })
        })
        : Yup.object({})
    );
  }, [currentTab]);

  const convertDataToTree = (data: any) => {
    const result: any = data.map((item: any, index: number) => {
      const addtionData = {
        khoaChiDinh: item.fulfillDeptName,
        ngayYLenh: item.indicationTime,
        ngayTraKetQua: item.resultReportingTime,
        orderId: item?.orderId,
      };
      return { ...termConvert([item.term], addtionData)[0], index: index + 1 };
    });
    return result;
  };

  const termConvert = (terms: any, addtionData: any) => {
    const result: any = terms.map((term: any) => ({
      id: term.id.toString(),
      parentId: term.parentId,
      tenDichVu: term.name,
      ketQua: term.obs?.value || "",
      khoaChiDinh: addtionData.khoaChiDinh,
      ngayYLenh: addtionData.ngayYLenh,
      ngayTraKetQua: addtionData.ngayTraKetQua,
      subRows: term.subs?.length ? termConvert(term.subs, addtionData) : null,
      orderId: addtionData?.orderId,
      isSelected: true,
    }));
    return result;
  };
  const handleGetResult = async () => {
    let searchObject = {
      orderId: selectedRow?.orderId,
    };
    let searchObjectKQCLS = selectedRow?.surgeryOrderId
      ? {
          surgeryOrderId: selectedRow?.surgeryOrderId,
        }
      : {
          orderId: selectedRow?.orderId,
        };
    try {
      setIsLoading(true);
      let { data } = await getObsValue(searchObject);
      if (data?.code === CODE.SUCCESS) {
        setInforResult(data?.data);
      }
    } catch (error) {
      console.error(error);
      toast.error("Xảy ra lỗi, vui lòng thử lại!");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCheckTabsByPermissions = () => {
    setListTabChecked(danhSachTab.filter((tab) => hasAuthority(tab.permission)));
  };

  const danhSachTab = useMemo(() => [
    {
      permission: KEY_AUTHORITIES.CHUYEN_KHOA.FORM_THUC_HIEN.VIEW,
      eventKey: "10",
      title: "Thông tin PTTT",
      component: (
        <FormPTTT
          infoBenhNhan={infoBenhNhan}
          isViewModal={isViewModal}
          inforResult={inforResult}
          currentTab={currentTab}
          selectedRow={selectedRow}
          setIsHasData={setIsHasData}
        />
      ),
    },
    {
      permission: KEY_AUTHORITIES.CHUYEN_KHOA.FORM_CHI_DINH.VIEW,
      eventKey: "12",
      title: "Thông tin chỉ định",
      component: (
        <FormThongTinChiDinh
          defaultTermModel="service-additional-info"
          expandForm={selectedRow?.attributes?.prescriptionFormExpand}
        />
      ),
    },
  ], [
    infoBenhNhan,
    isViewModal,
    inforResult,
    selectedRow,
  ]);

  useEffect(() => {
    handleCheckTabsByPermissions();
  }, [danhSachTab])

  useEffect(() => {
    handleGetResult();
  }, []);

  return (
    <Modal
      show={true}
      onHide={handleClose}
      size="xl"
      centered
      className="modal-xl-bigger modal-chuyen-khoa"
      contentClassName="h-100"
    >
      <Formik
        initialValues={{ formData: initialValues }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          let valuesSubmit = {
            ...values?.formData,
          };
          handleSubmitForm(valuesSubmit);
        }}
        innerRef={refForm}
      >
        {({ handleSubmit }) => {
          return (
            <Form>
              <Modal.Header className="p-4 header-modal header-modal-chuyen-khoa">
                <Modal.Title>Thực hiện dịch vụ</Modal.Title>
                <button className="btn-close" onClick={handleClose}></button>
              </Modal.Header>
              <TabMenu
                danhsachTabs={listTabChecked}
                handlerSelect={(activeTab: any) => setCurrentTab(+activeTab)}
              />
              {!(!editable || isViewModal) && (
                <Modal.Footer>
                  {isHasData && (
                    <>
                      <ButtonInPhieu<IInPhieuParams>
                        typeBtn="btn-outline btn-outline-pttt"
                        label="Phiếu phẫu thuật"
                        fetchExport={inPhieuPhauThuat}
                        params={{
                          orderId: selectedRow?.orderId || null,
                        }}
                      />
                      <ButtonInPhieu<IInPhieuParams>
                        typeBtn="btn-outline btn-outline-pttt"
                        label="Giấy chứng nhận"
                        fetchExport={inGiayChungNhan}
                        params={{
                          orderId: selectedRow?.orderId || null,
                        }}
                      />
                    </>
                  )}
                  <Button className="btn-fill spaces min-w-50" onClick={() => handleSubmit()}>
                    Lưu
                  </Button>
                </Modal.Footer>
              )}
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
}
